export var StartDateText;
(function (StartDateText) {
    StartDateText["NoDaysAvailableText"] = "Please select at least one day of week for your order!";
})(StartDateText || (StartDateText = {}));
